import { Err } from '.';

export enum EnumEstadoPin {
  PEDIDO = 1,
  ANULADO = 2,
  CONFIRMADO = 3,
  USADO = 4,
}

export enum EnumEstadoPinMensaje {
  VIGENTE = 'Vigente',
  USADO = 'Usado',
}

export interface ResponseAssociatePins {
  /**
   * true / false.
   * @description Indica si hubo un error o no.
   */
  estado: boolean;
  /**
   * mensaje de error
   * @description si estado == false.
   */
  mensaje?: string;
  /**
   * código de error. Especiales para este pedido: <li> null ó -1: Mostrá el mensaje directamente. </li> <li> 3901: pin no válido </li> <li> 3902: tipo de pin no válido </li> <li> 3903: pin ya asociado a otra cuenta </li> <li> </li>
   * Format: int32
   * @description si estado == false.
   */
  codError?: number;
  error?: Err;
  /**
   * pines disponibles
   * Format: int32
   * @description Pines disponibles en cuenta del usuario
   */
  pinesDisponibles?: number;
  /**
   * saldo disponible
   * @description saldo del usuario
   */
  saldo?: number;
  /**
   * es premium?
   * @description Indica si es premium
   */
  premium?: boolean;
  /**
   * deprecated - activación tienda
   * @description deprecated - Indica si la activación 'tienda auspiciante' está disponible para el usuario.
   * (ej: está configurada + el usuario cumple el requisito de ser premium)
   */
  tiendaAuspiciante?: boolean;
}

/**
 * This file was auto-generated by openapi-typescript.
 * Do not make direct changes to the file.
 */

export interface paths {
  '/cuentas/transferir-saldo-envio': {
    /** Paso 2. (envío). Response: <br>Response de transferencia de saldo. <br>Consulta previa o envío. <br>En envío devuelve datos de actualización de cuenta (pinesDisponibles/saldo).<br>En consulta devuelve datos de destinatario.<br>theData.codError: <li>(consulta)123: No existe el usuario con..</li><li>123: No existe el usuario con..</li><li>USUARIO_NO_EXISTE	(172, "El usuario no existe."),</li> <li>TRANSFERENCIA_A_SI_MISMO (611, "No podés (..) a vos mismo."),</li> <li>BLACKLISTED_USER_1	(609, "Detectamos actividad irregular en.."),</li> <li>SIN_SALDO		(600, "No tenés saldo disponible (..)"),</li> */
    post: operations['transferirSaldoEnvio'];
  };
  '/cuentas/prepare-payu-send': {
    /** Genera los datos para crear el formulario de checkout de payu. <br/>con estos datos creás un form html y hacés el post. <br/>Doc de checkout: https://developers.payulatam.com/latam/es/docs/integrations/webcheckout-integration/payment-form.html */
    post: operations['sendPayu'];
  };
  '/cuentas/gw-sync-response-redirector': {
    /** Bug en nginx, no acepta POST. Hago este redirect intermedio para llegar a /form-pagos/gw-form-response-sync.html?estado=ACREDITADO&idTransaccionCliente=81851804 */
    post: operations['responseSyncRedirector'];
  };
  '/cuentas/compra-con-saldo': {
    /** Compra asumiendo que el usuario tiene saldo en su cuenta.<br>En pines especiales luego de la compra intenta usar el pin (eg inscripción FeOro) */
    post: operations['compraConSaldo'];
  };
  '/cuentas/busqueda-mapa': {
    post: operations['busquedaMapa'];
  };
  '/cuentas/asociar-pin-existente': {
    /** Asociación de un pin a cuenta <br> El pin ingresado debe estar libre (no asociado a otro usuario, no usado, no anulado). */
    post: operations['asociarPinExistente'];
  };
  '/cuentas/GWPAGOSMobileServlet': {
    /** . <br>url alternativa: [URL_ENTORNO]/srv/GWPAGOSMobileServlet <br>Devuelve el formulario de pagos (html). <br>La respuesta del formulario es configurable, debemos escribir un html que tome un parámetro '&estado=ACREDITADO'. Ese html debe manejar la respuesta. Llamamos a esto 'respuesta sincrónica'. La que maneja la acreditación es la respuesta asincrónica (interna). */
    post: operations['formDePago'];
  };
  '/cuentas/trx-pendientes': {
    /** [URL_ENTORNO]/grandt/mobileWM.html?_action=trxPendVisa<br>Consulta si tiene transacciones con tarjeta pendientes. <br>Controlar en este orden:<br><li>{blacklist} Si es infractor, mostrarle msg {blacklist_msg} </li><li>{minTrxAnterior} Si hubo una acreditación exitosa muy reciente, avisarle.</li><li>{minsRestantes} Si en los últimos 30 minutos fue al formulario de pago, pedirle que espere.</li> */
    get: operations['checkTrxPendientes'];
  };
  '/cuentas/transferir-saldo-consulta': {
    /** Paso 1. consulta. Response: <br>Response de transferencia de saldo. <br>Consulta previa o envío. <br>En envío devuelve datos de actualización de cuenta (pinesDisponibles/saldo).<br>En consulta devuelve datos de destinatario.<br>theData.codError: <li>(consulta)123: No existe el usuario con..</li><li>123: No existe el usuario con..</li><li>USUARIO_NO_EXISTE	(172, "El usuario no existe."),</li> <li>TRANSFERENCIA_A_SI_MISMO (611, "No podés (..) a vos mismo."),</li> <li>BLACKLISTED_USER_1	(609, "Detectamos actividad irregular en.."),</li> <li>SIN_SALDO		(600, "No tenés saldo disponible (..)"),</li> */
    get: operations['transferirSaldoConsulta'];
  };
  '/cuentas/tc-tokenizadas': {
    /** Lista de TC usadas anteriormente (pero tokenizadas). <br> El form de pago recibe sólo tokenizadas[].token <br>ver https://en.wikipedia.org/wiki/Tokenization_(data_security) <br>Vos le mostrás al usuario la información mínimo de la tarjeta para identificarla (ver doc de la lista de tokenizadas). */
    get: operations['tarjetasTokenizadas'];
  };
  '/cuentas/productos-disponibles': {
    /** Lista de productos <br>Filtrados y no filtrados. Ver explicación en el response.<br> */
    get: operations['obtenerProductosDisponibles'];
  };
  '/cuentas/montos-carga': {
    get: operations['obtenerMontosCarga'];
  };
  '/cuentas/init': {
    /** Pedido inicial mis pines <br>Listado de movimientos e indicaciones para saber como mostrar los productos que se trajeron en otro endpoint. */
    get: operations['pedidoInicial'];
  };
}

export interface components {
  schemas: {
    /**
     * Datos de cuenta del usuario
     * @description Datos para la actualización de la cabecera de la cuenta del usuario (premium/saldo/pines/etc..)
     */
    ResponseActualizacionDatosCuenta: {
      /**
       * pines disponibles
       * Format: int32
       * @description Pines disponibles en cuenta del usuario
       */
      pinesDisponibles?: number;
      /**
       * saldo disponible
       * @description saldo del usuario
       */
      saldo?: number;
      /**
       * es premium?
       * @description Indica si es premium
       */
      premium?: boolean;
      /**
       * deprecated - activación tienda
       * @description deprecated - Indica si la activación 'tienda auspiciante' está disponible para el usuario.
       * (ej: está configurada + el usuario cumple el requisito de ser premium)
       */
      tiendaAuspiciante?: boolean;
    };
    /** @description Response de transferencia de saldo. <br>Consulta previa o envío. <br>En envío devuelve datos de actualización de cuenta (pinesDisponibles/saldo).<br>En consulta devuelve datos de destinatario.<br>theData.codError: <li>(consulta)123: No existe el usuario con..</li><li>123: No existe el usuario con..</li><li>USUARIO_NO_EXISTE	(172, "El usuario no existe."),</li> <li>TRANSFERENCIA_A_SI_MISMO (611, "No podés (..) a vos mismo."),</li> <li>BLACKLISTED_USER_1	(609, "Detectamos actividad irregular en.."),</li> <li>SIN_SALDO		(600, "No tenés saldo disponible (..)"),</li> */
    ResponseTransferenciaSaldo: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /**
       * @description (solo en consulta) nombre completo del destinatario de la transferencia
       * @example Juan Pérez
       */
      nombreUsuarioTrans?: string;
      /**
       * @description (solo en consulta) Descripción del tipo de documento del destinatario de la transferencia
       * @example LE
       */
      tipoDoc?: string;
      actualizacionCuenta?: components['schemas']['ResponseActualizacionDatosCuenta'];
    };
    /** @description ver extenal doc */
    FormPayu: {
      merchantId?: string;
      accountId?: string;
      description?: string;
      referenceCode?: string;
      amount?: string;
      currency?: string;
      signature?: string;
      test?: string;
      buyerFullName?: string;
      buyerEmail?: string;
      responseUrl?: string;
      confirmationUrl?: string;
    };
    /** @description Genera los datos para crear el formulario de checkout de payu. <br/>con estos datos creás un form html y hacés el post. <br/>Doc de checkout: https://developers.payulatam.com/latam/es/docs/integrations/webcheckout-integration/payment-form.html */
    ResponseFormPayu: {
      form?: components['schemas']['FormPayu'];
      /** @description url para hacer el post */
      url?: string;
    };
    ResponseBase: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
    };
    /**
     * Fecha
     * @description  fecha en que inicia el tap/feoro
     * @example {"id":992,"nombre":"Fecha
     *         22","orden":21,"isPublicada":false}
     */
    FechaTO: {
      /**
       * id de fecha
       * Format: int32
       */
      id?: number;
      /** nombre de fecha */
      nombre?: string;
      /**
       * orden de fecha
       * Format: int32
       */
      orden?: number;
      /**
       * idRnkPublicado
       * Format: int32
       * @description ojo, solo usar en GrupoCopaAmigos
       */
      idRnkPublicado?: number;
      publicada?: boolean;
    };
    /** @description Compra asumiendo que el usuario tiene saldo en su cuenta.<br>En pines especiales luego de la compra intenta usar el pin (eg inscripción FeOro) */
    ResponseComprarProducto: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error. Especiales para este pedido: <li> null ó -1: Mostrá el mensaje directamente. </li> <li> 124: Acaba de cambiar el precio de ese producto .. 		Volvé a ingresar para actualizar la lista</li> <li> </li>
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      resultadoUsoCD?: components['schemas']['ResultadoUsoProducto'];
      /** @description Lista de pines comprados, si corresponde */
      pines_comprados?: string[];
    };
    /** @description pin comprado fue usado? (eg ta por premios)<br>IMPORTANTE: Si es TA x premios => devuelve schema 'TAPorPremioTO', 		que es subclase de 'ResultadoUsoProducto'.<br> Buscar definición en ResponseListarTapsUsuario. */
    ResultadoUsoProducto: Partial<components['schemas']['TAPorPremioTO']>;
    /** Info del TAP o FeOro */
    TAPorPremioTO: {
      /**
       * Nombre del TAP
       * @example Torneo de Amigos por Premios #420
       */
      nombre?: string;
      /**
       * id del TAP
       * Format: int32
       * @description usar para la inscripción.
       */
      id?: number;
      /**
       * cantidad de participantes
       * Format: int32
       * @description cantidad de participantes ya inscriptos (0..20)
       */
      cantPart?: number;
      /**
       * tipo de pin asociado al tap/feoro
       * Format: int32
       * @description Alguno de estos ids: 	PIN_TAP_1(19,"Pin Especial TdA por Premios (1)", ""),//$200
       * 	PIN_TAP_2(20,"Pin Especial TdA por Premios (2)", ""),//$500
       * 	PIN_TAP_3(21,"Pin Especial TdA por Premios (3)", ""),//$1000
       *
       * @enum {integer}
       */
      idTipoPin?: 19 | 20 | 21;
      /** nombre de la fecha de inscripción */
      nombreFecha?: string;
      /**
       * Se uso el cupo gratuito (soc) de este TAP.
       * @description No usar. <br>Preferir el campo 'pinObligatorio' del servicio de datos de inscripción.<br>Antes permitía que el primer inscripto de cada TAP fuese gratuito. Ahora las reglas son más complicadas.
       */
      gratuitaFueUsada?: boolean;
      /**
       * premio del TAP
       * Format: int32
       * @description Premio en pesos del TAP
       */
      premio?: number;
      fechaInicio?: components['schemas']['FechaTO'];
      strPin?: string;
      usoPinDeCD?: boolean;
    };
    RequestUbicacionMapa: {
      /**
       * @description latitud
       * @example -34.6901943
       */
      lat?: number;
      /**
       * @description longitud
       * @example -58.5087264
       */
      lng?: number;
      /**
       * Format: int32
       * @description Cantidad de resultados
       * @default 50
       * @example 3
       */
      maxCant?: number;
      /**
       * @description Dejar en 50 o 100. <br>Esto limita un poco los resultados, ANTES de ordenar por GCD (great-circle distance).Pero usa una aproximación de 'grados por km' muy inexacta.
       * @default 100
       * @example 50
       */
      km2?: string;
      /**
       * @description CSV. Filtro de proveedores de carga. <br>valores posibles ('SEAC','FC','REV').<br>ver EnumProveedorExterno. Serían RGP_EX_SEAC,REVIRTUAL,FULLCARGA<br>IMPORTANTE: SEAC vende ticket impreso (5 pines). El resto no.<br> pasar SEAC (link 'ticket impreso') o vacío (link 'carga virtual y terminales pago24')
       * @example SEAC
       */
      proveedores?: string;
    };
    ResponseUbicacionMapa: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error (opcional)
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      marker?: components['schemas']['UbicacionMapa'][];
    };
    UbicacionMapa: {
      /** Format: int32 */
      id?: number;
      nombre?: string;
      domicilio?: string;
      /** Format: int32 */
      idProvincia?: number;
      /** Format: int32 */
      idPartido?: number;
      /** Format: int32 */
      idLocalidad?: number;
      latitud?: number;
      longitud?: number;
      nombreProvincia?: string;
      nombrePartido?: string;
      nombreLocalidad?: string;
      distancia?: number;
      proveedor?: string;
    };
    /** @description Asociación de un pin a cuenta <br> El pin ingresado debe estar libre (no asociado a otro usuario, no usado, no anulado). */
    ResponseAsociarPin: {
      /**
       * true / false.
       * @description Indica si hubo un error o no.
       */
      estado: boolean;
      /**
       * mensaje de error
       * @description si estado == false.
       */
      mensaje?: string;
      /**
       * código de error. Especiales para este pedido: <li> null ó -1: Mostrá el mensaje directamente. </li> <li> 3901: pin no válido </li> <li> 3902: tipo de pin no válido </li> <li> 3903: pin ya asociado a otra cuenta </li> <li> </li>
       * Format: int32
       * @description si estado == false.
       */
      codError?: number;
      /**
       * pines disponibles
       * Format: int32
       * @description Pines disponibles en cuenta del usuario
       */
      pinesDisponibles?: number;
      /**
       * saldo disponible
       * @description saldo del usuario
       */
      saldo?: number;
      /**
       * es premium?
       * @description Indica si es premium
       */
      premium?: boolean;
      /**
       * deprecated - activación tienda
       * @description deprecated - Indica si la activación 'tienda auspiciante' está disponible para el usuario.
       * (ej: está configurada + el usuario cumple el requisito de ser premium)
       */
      tiendaAuspiciante?: boolean;
    };
    /** @description [URL_ENTORNO]/grandt/mobileWM.html?_action=trxPendVisa<br>Consulta si tiene transacciones con tarjeta pendientes. <br>Controlar en este orden:<br><li>{blacklist} Si es infractor, mostrarle msg {blacklist_msg} </li><li>{minTrxAnterior} Si hubo una acreditación exitosa muy reciente, avisarle.</li><li>{minsRestantes} Si en los últimos 30 minutos fue al formulario de pago, pedirle que espere.</li> */
    ResponseTransaccionesPendientesVisa: {
      estado?: boolean;
      /**
       * @description Si blacklist == true, mostrarle este mensaje al usuario.
       * @example Detectamos actividad irregular en tus transacciones en el juego que están siendo analizadas. Por el momento no podés realizar la acción requerida. Para más información ver artículos 4.4 y 7.1 del Reglamento.
       */
      blacklist_msg?: string;
      /** @description El usuario realizó transacciones irregulares, no puede hacer compras. Mostrar 'blacklist_msg' */
      blacklist?: boolean;
      /**
       * Format: int32
       * @description Minutos que faltan para que se cumplan los 30' desde el último intento de pago PENDIENTE.<br><br>Mostrar: 'Tenés una transacción en procesamiento, esperá {minsRestantes} minutos y volvé a chequear tus movimientos.¿Querés continuar de todos modos?'
       */
      minsRestantes?: number;
      /**
       * Format: int32
       * @description Minutos que pasaron desde la última acreditación EXITOSA.<br> Mostrar: 'Tu última transacción exitosa fue hace {minTrxAnterior} minutos. ¿Querés continuar de todos modos?'
       */
      minTrxAnterior?: number;
    };
    /** @description (BD GDT) En descripcionBin.descripcionGdt está el nombre del banco correspondiente a '.bin' (Bank Identification Number)<br>No conocemos a todos los bancos, PUEDE SER NULL. Ver doc del response para saber qué hacer ahí. */
    Bin: {
      /** Format: int32 */
      id?: number;
      descripcion?: string;
      /** Format: int32 */
      numero?: number;
      emisor?: string;
      tipo?: string;
      descripcionGdt?: string;
    };
    /** @description Lista de TC usadas anteriormente (pero tokenizadas). <br> El form de pago recibe sólo tokenizadas[].token <br>ver https://en.wikipedia.org/wiki/Tokenization_(data_security) <br>Vos le mostrás al usuario la información mínimo de la tarjeta para identificarla (ver doc de la lista de tokenizadas). */
    ResponseTarjetasTokenizadas: {
      /** @description Lista de TC usadas anteriormente. */
      tokenizadas?: components['schemas']['TarjetaTokenizada'][];
      /** @description Hubo un error al obtener las tarjetas.Normalmente vacío. Imprimir en console.error un este error. (NO se falla por esto, se continua como si no hubiera tarjetas tokenizadas). */
      warning?: string;
    };
    /**
     * @description Tarjeta tokenizada devuelta por el gateway + datos extra internos.<br>'token' es para enviar al form de pagos. <br>El resto es para describir la tarjeta en un select.<br>ver gdt.js, buscar esto: <code> descripcionMedioPago: elem.descripcionBin.descripcionGdt || describirPorCodigoMedioPago(elem.codigoMedioPagoGdt) </code> y luego getSelected(..)<br>El select muestra banco (si lo conocemos) o defaultea a la marca de la tarjeta. Al seleccionarla muestra la máscara con 'lastFourDigits' (getSelected(..).label.
     * @example {
     *   "token": "c223bbf89dd86fde9dd1b7e2cd1a9e4fa0d93be58ed31de8d0f81073a0a963b6",
     *   "codigoMedioPago": "VISA",
     *   "bin": "450799",
     *   "lastFourDigits": "4905",
     *   "expirationMonth": "12",
     *   "expirationYear": "20",
     *   "codigoMedioPagoGdt": "amex",
     *   "descripcionBin": {
     *     "descripcionGdt": "Banco Santander Río"
     *   }
     * }
     */
    TarjetaTokenizada: {
      token?: string;
      /**
       * @description Antes 'codigoMedioPago' y 'codigoMedioPagoGdt' (gui) eran distintos.<br>Este se envía al form de pagos.<br> interno: EnumCodigoMedioPagoGateway
       * @enum {string}
       */
      codigoMedioPago?:
        | 'credito'
        | 'debito'
        | 'mc'
        | 'amex'
        | 'maestro'
        | 'naranja'
        | 'cabal';
      /** @description bank identification number */
      bin?: string;
      /** @description obvio. Este lo mostramos. */
      lastFourDigits?: string;
      expirationMonth?: string;
      expirationYear?: string;
      descripcionBin?: components['schemas']['Bin'];
      /** @description (BD GDT) Antes 'codigoMedioPago' y 'codigoMedioPagoGdt' (gui) eran distintos.<br> ver codigoMedioPago<br> este siempre viene en minúsculas! El otro no sé. */
      codigoMedioPagoGdt?: string;
    };
    /** @description Lista de productos <br>Filtrados y no filtrados. Ver explicación en el response.<br> */
    ResponseProductosDisponibles: {
      estado?: boolean;
      /** @description Filtrada para Mis Pines <br>Si la inscripción para TAP/FeOro u otra activación asociada no está abierta => EL PRODUCTO NO APARECE EN LA LISTA.Usar en el listado de productos y evitar en cualquier otro lugar. */
      productos?: components['schemas']['TipoProductoTO'][];
      /** @description Sin filtrar. <br>Para búsquedas por id/sku ('obtenerProductoPorId'). <br> Entre el inicio y el fin de una tx puede cerrar la inscripción.  El sistema no puede fallar en ese caso. Igualmente, confiar en la lista filtrada no está bien. */
      productosTodos?: components['schemas']['TipoProductoTO'][];
    };
    /** @description Cuotas disponibles para el producto/oferta */
    TipoProductoCuotaPrecioTOMobile: {
      /**
       * Format: int32
       * @description obvio
       */
      cantidadCuotas: number;
      /** @description obvio */
      precioCuota: number;
      /** @description precio con interés */
      montoTotal: number;
      /**
       * Format: int32
       * @description obvio
       */
      idTipoProducto: number;
    };
    /** @description Describe un producto */
    TipoProductoTO: {
      /**
       * Format: int32
       * @description id de producto
       */
      id: number;
      /** @description precio actual (customizado para usuario por oferta) */
      precio: number;
      /** @description nombre del producto */
      descripcion: string;
      /** @description true si se trata del producto premium */
      esPremium: boolean;
      /**
       * Format: int32
       * @description cantidad disponible de productos (pines) dentro de un paquete. Sólo válido para paquetes.<br>precioUnitario = decimal(p.precio / p.cantidad)
       */
      cantidad?: number;
      /**
       * @description prefijo de compra directa. Hoy no usado en frontend.<br>Son dos dígitos para armar el código de pagomiscuentas/pagos link.
       * @example 02
       */
      prefijoCD?: string;
      /** @description Código de producto de Google Play (app android). Se relaciona 1 a 1 con el identificador de producto GDT. */
      sku?: string;
      /** @description Cuotas disponibles, si corresponde */
      tipoProductoCuotaPrecioTO?: components['schemas']['TipoProductoCuotaPrecioTOMobile'][];
      /**
       * Format: int32
       * @description sale de ETipoProductoGDT<br>Muy relevante para TAP y FeOro. <br>Algunos EJEMPLOS: <br><li>PIN(1, "Pin" , ETipoPin.PIN_WEB /*1*\/),</li><li>(los paqueten devuelven NULL!!)</li><li>PIN_F5(12, "Pin Fútbol 5", ETipoPin.PIN_F5),</li><li>..</li><li>PIN_TAP_1(30, "Pin Especial Torneo de Amigos por Premios", ETipoPin.PIN_TAP_1/*19*\/), </li><li>.. PIN_TAP_3(32, "Pin Especial Torneo de Amigos por Premios",  ETipoPin.PIN_TAP_3/*21*\/),</li><li>PIN_FEORO (33, "Pin Especial Fecha de Oro",  ETipoPin.PIN_FEORO),</li><li>..</li><li>PIN_REGALO_PIM (36, "Pin de Regalo (PIM)", ETipoPin.PIN_WEB),</li>
       */
      idTipoPin?: number;
      /**
       * Format: int32
       * @description Nos indica que hay una oferta activa, es decir, el p.precio no es el precio de lista. Una oferta modifica el precio y las cuotas.
       */
      idOferta?: number;
      /**
       * Format: int32
       * @description  Cualquier oferta distinta de '0' significa que hubo una oferta. <br>Se usa en el frontend, pero no es imprescindible. (podría usar p.idOferta != p.id)	OFERTA_DEFAULT_EMBEBIDA(0, "Embebida"), // DEFAULT para el TipoProducto, tipo embebido. No usar en entidad "Oferta".
       * 	POR_STOCK(1, "Por Stock"), // ver wc.getCountConsumosPorOferta
       * 	POR_USUARIO_BD(2, "Por Usuario en Base"), // valen sólo para subconjuntos de usuarios, ver ItemOfertaUsuario
       * 	POR_USUARIO_SEGM(3, "Por Usuario Segmentada") // segm
       */
      idTipoOferta?: number;
      /** @description Precio sin considerar la oferta.<br>En algunos lugares está este código (evitémoslo, si es posible):<br> int montoPremio = montoPin*10; <br>Si no se puede evitar, nunca usar una oferta. */
      precioDeLista?: number;
      /**
       * @description Debajo del precio se suele poner una leyenda tipo '¡Oportunidad única!'
       * @example 50% Off
       */
      txtOferta?: string;
    };
    /** @description Item del select de montos */
    MontoCargaTo: {
      monto?: number;
      selected?: boolean;
    };
    /** @description Response montos de carga */
    ResponseMontosCarga: {
      estado?: boolean;
      /** @description Lista ordenada por monto. Se selecciona el monto del premium.<br>El monto de premium cambia según el usuario (hay ofertas válidas sólo para algunos usuarios). */
      montosValidos?: components['schemas']['MontoCargaTo'][];
    };
    /** @description obvio */
    DetalleMovimientoCuentaMobileTO: {
      /**
       * Format: int32
       * @description id de movimiento
       */
      id?: number;
      /** @description fecha (dd/MM/yyyy) */
      fecha?: string;
      /** @description descripción */
      descripcion?: string;
      /**
       * @description monto de la operación. Float, formateado con punto (inglés)
       * @example 50.1
       */
      monto?: string;
      /** @description saldo resultante al momento de la operación. */
      saldo?: string;
      /** @description Es compra en dólares (no mostrar el monto y saldo). Sólo mostrar la descripción que contiene el valor en dólares. */
      taparMonto?: string;
      /**
       * Format: int32
       * @description id del tipo de ingreso (identifica el método de carga de saldo, PMC, Link, PAYU, VISA, ...)
       */
      idTipoIngreso?: number;
      /**
       * Format: int32
       * @description Estado del pin (si es pin).<br>EnumEstadoPin:  <li> PEDIDO(1, "vigente"), </li>	<li> ANULADO(2, "anulado"), </li>	<li> CONFIRMADO(3, "vigente"), </li>	<li> UTILIZADO(4, "usado") </li>	<li> <b>null o -1</b> no aplica </li>
       */
      idEstadoItem?: number;
      pack?: boolean;
    };
    InfoImpresionPromocion: {
      /** Format: int32 */
      idInterno?: number;
      /** Format: int32 */
      id?: number;
      name?: string;
      creative?: string;
      position?: string;
    };
    LinkEmbeddedFullTo: {
      /** Format: int32 */
      idLinkeable?: number;
      link?: string;
      linkWM?: string;
      linkApp?: string;
      /** @enum {string} */
      elinkeable?: 'Externo' | 'Interno' | 'Sin Link';
    };
    /** @description Popup imagen/video a mostrar. */
    PopupVideoImagenTO: {
      /** Format: int32 */
      id?: number;
      tipo?: string;
      urlImagen?: string;
      /**
       * Format: int32
       * @deprecated
       */
      idLinkeable?: number;
      /** @deprecated */
      urlLink?: string;
      /** Format: int32 */
      idFrecuencia?: number;
      /** Format: int32 */
      idModulo?: number;
      infoImpresionPromocion?: components['schemas']['InfoImpresionPromocion'];
      linkData?: components['schemas']['LinkEmbeddedFullTo'];
      /** Format: int32 */
      link?: number;
    };
    /** @description Pedido inicial mis pines <br>Listado de movimientos e indicaciones para saber como mostrar los productos que se trajeron en otro endpoint. */
    ResponseMiCuenta: {
      estado?: boolean;
      /** @description Torneo de amigos por premios tiene la inscripción abierta */
      tapHabilitado?: boolean;
      /** @description Fecha de Oro tiene la isncripción abierta */
      feoroHabilitado?: boolean;
      /** @description ignorar. */
      unoVunoHabilitado?: boolean;
      /** @description IGNORAR, por eliminar. */
      fePlatinoHabilitado?: boolean;
      /** @description Popup imagen/video a mostrar. */
      popups_cuenta?: components['schemas']['PopupVideoImagenTO'][];
      /** @description obvio */
      movimientos?: components['schemas']['DetalleMovimientoCuentaMobileTO'][];
      /**
       * Format: float
       * @description saldo. <br>saldo/pines/premium se relee de la BD (no hay ninguna cache).<br>Es importante actualizar el header con esta información.
       */
      saldo?: number;
      /** @description es premium? */
      premium?: boolean;
      /** @description valor, ya formateado, al que compró premium.<br>El el listado de precios NUNCA mostramos una oferta posterior a lo que el usuario compró. */
      valorAlQueComproPremium?: string;
      /**
       * Format: int32
       * @description Cant. de pines que le quedan en la cuenta.
       */
      pinesDisponibles?: number;
      /** @description ignorar. */
      tiendaAuspiciante?: boolean;
      sobreescrituraPremium?: components['schemas']['ResponseSobreescrituraPremiumTo'];
    };
    /** @description Ignorar. Acción 2024-04, promoción sinergia olé. <br> Se le pide a los clientes que sobreescriban los links a compra de pack premium con un precio nulo y un link a '$.landing' */
    ResponseSobreescrituraPremiumTo: {
      /** @description Debo sobreescribir link a compra de premium? */
      aplica?: boolean;
      /** @description Landing destino */
      landing?: string;
      /** @description cambiar con esto el subtexto de oferta del link (si existiera). Ej de subtexto de oferta: '¡Oportunidad única!', '¡Ahora 50% Off!', etc.. */
      txtOferta?: string;
    };
  };
}

export interface operations {
  /** Paso 2. (envío). Response: <br>Response de transferencia de saldo. <br>Consulta previa o envío. <br>En envío devuelve datos de actualización de cuenta (pinesDisponibles/saldo).<br>En consulta devuelve datos de destinatario.<br>theData.codError: <li>(consulta)123: No existe el usuario con..</li><li>123: No existe el usuario con..</li><li>USUARIO_NO_EXISTE	(172, "El usuario no existe."),</li> <li>TRANSFERENCIA_A_SI_MISMO (611, "No podés (..) a vos mismo."),</li> <li>BLACKLISTED_USER_1	(609, "Detectamos actividad irregular en.."),</li> <li>SIN_SALDO		(600, "No tenés saldo disponible (..)"),</li> */
  transferirSaldoEnvio: {
    parameters: {
      query: {
        /** tipo de documento (1/2/3 => es DNI,LC,LE). ver ETipoDocumento. */
        tipoDoc: string;
        /** nro de documento */
        nroDoc: number;
        /** monto */
        montoATransf: number;
        /**
         * id motivo. EMotivoTransfSaldo. <br>Posibles: 	(1, "Apuesta Perdida"),
         * 	(2, "Regalo"),
         * 	(10, "Otro")
         */
        opcionMotivo: number;
        /** texto de motivo (si, opcionMotivo == 10, 'otro') */
        txtMotivoOtro?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': components['schemas']['ResponseTransferenciaSaldo'];
        };
      };
    };
  };
  /** Genera los datos para crear el formulario de checkout de payu. <br/>con estos datos creás un form html y hacés el post. <br/>Doc de checkout: https://developers.payulatam.com/latam/es/docs/integrations/webcheckout-integration/payment-form.html */
  sendPayu: {
    parameters: {
      query: {
        monto: string;
        /** id tipo de producto */
        tipoProducto?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseFormPayu']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
  /** Bug en nginx, no acepta POST. Hago este redirect intermedio para llegar a /form-pagos/gw-form-response-sync.html?estado=ACREDITADO&idTransaccionCliente=81851804 */
  responseSyncRedirector: {
    parameters: {
      query: {
        /** ACREDITADO / RECHAZADO */
        estado?: string;
        /** id TX */
        idTransaccionCliente?: string;
      };
    };
    responses: {
      /** Found */
      302: never;
    };
  };
  /** Compra asumiendo que el usuario tiene saldo en su cuenta.<br>En pines especiales luego de la compra intenta usar el pin (eg inscripción FeOro) */
  compraConSaldo: {
    parameters: {
      query: {
        /** id de tipo de producto. Default es 1 (pin común)<br>Ver BD (tbl TipoProducto). Lista a Oct 2023:<br> <li>1 pin común</li><li>3,5,25 Paquetes de pines (increyendo)</li><li>19 pack premium </li><li>30,31,32 pin TAP (increyendo)</li><li>33 pin Feoro</li> */
        id?: string;
        /** precio esperado, formato inglés (coma). No obligatorio. */
        precioEsperado?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseComprarProducto']
          >;
        };
      };
    };
  };
  busquedaMapa: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': components['schemas']['ResponseUbicacionMapa'];
        };
      };
    };
    requestBody: {
      content: {
        'application/x-www-form-urlencoded': components['schemas']['RequestUbicacionMapa'];
      };
    };
  };
  /** Asociación de un pin a cuenta <br> El pin ingresado debe estar libre (no asociado a otro usuario, no usado, no anulado). */
  asociarPinExistente: {
    parameters: {
      query: {
        /** PIN */
        pin?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseAsociarPin']
          >;
        };
      };
    };
  };
  /** . <br>url alternativa: [URL_ENTORNO]/srv/GWPAGOSMobileServlet <br>Devuelve el formulario de pagos (html). <br>La respuesta del formulario es configurable, debemos escribir un html que tome un parámetro '&estado=ACREDITADO'. Ese html debe manejar la respuesta. Llamamos a esto 'respuesta sincrónica'. La que maneja la acreditación es la respuesta asincrónica (interna). */
  formDePago: {
    parameters: {
      query: {
        /** monto. Dos decimales, con punto (inglés). */
        monto: string;
        /** key de este objeto: <br>var CONF_TARJETAS = {     'credito': { nombre: 'VISA CRÉDITO.'},  <br>    'mc': { nombre: 'MASTERCARD'} ,      'amex': { nombre: 'AMERICAN EXPRESS'} , <br>     'maestro': { nombre: 'MAESTRO' , debito: true } ,      'debito': { nombre: 'VISA DÉBITO' , debito: true}, <br>    'cabal': { nombre: 'CABAL', "disabled": true},     'naranja': { nombre: 'NARANJA', "disabled": true} } */
        canalVisa: string;
        /** id de producto (si es compra directa). */
        tipoProducto?: string;
        /** obvio. default 1. */
        cantidadCuotas?: string;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'text/html': unknown;
        };
      };
    };
  };
  /** [URL_ENTORNO]/grandt/mobileWM.html?_action=trxPendVisa<br>Consulta si tiene transacciones con tarjeta pendientes. <br>Controlar en este orden:<br><li>{blacklist} Si es infractor, mostrarle msg {blacklist_msg} </li><li>{minTrxAnterior} Si hubo una acreditación exitosa muy reciente, avisarle.</li><li>{minsRestantes} Si en los últimos 30 minutos fue al formulario de pago, pedirle que espere.</li> */
  checkTrxPendientes: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseTransaccionesPendientesVisa']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
  /** Paso 1. consulta. Response: <br>Response de transferencia de saldo. <br>Consulta previa o envío. <br>En envío devuelve datos de actualización de cuenta (pinesDisponibles/saldo).<br>En consulta devuelve datos de destinatario.<br>theData.codError: <li>(consulta)123: No existe el usuario con..</li><li>123: No existe el usuario con..</li><li>USUARIO_NO_EXISTE	(172, "El usuario no existe."),</li> <li>TRANSFERENCIA_A_SI_MISMO (611, "No podés (..) a vos mismo."),</li> <li>BLACKLISTED_USER_1	(609, "Detectamos actividad irregular en.."),</li> <li>SIN_SALDO		(600, "No tenés saldo disponible (..)"),</li> */
  transferirSaldoConsulta: {
    parameters: {
      query: {
        /** tipo de documento (1/2/3 => es DNI,LC,LE). ver ETipoDocumento. */
        tipoDoc: string;
        /** nro de documento */
        nroDoc: number;
      };
    };
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': components['schemas']['ResponseTransferenciaSaldo'];
        };
      };
    };
  };
  /** Lista de TC usadas anteriormente (pero tokenizadas). <br> El form de pago recibe sólo tokenizadas[].token <br>ver https://en.wikipedia.org/wiki/Tokenization_(data_security) <br>Vos le mostrás al usuario la información mínimo de la tarjeta para identificarla (ver doc de la lista de tokenizadas). */
  tarjetasTokenizadas: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseTarjetasTokenizadas']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
  /** Lista de productos <br>Filtrados y no filtrados. Ver explicación en el response.<br> */
  obtenerProductosDisponibles: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseProductosDisponibles']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
  obtenerMontosCarga: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseMontosCarga']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
  /** Pedido inicial mis pines <br>Listado de movimientos e indicaciones para saber como mostrar los productos que se trajeron en otro endpoint. */
  pedidoInicial: {
    responses: {
      /** OK */
      200: {
        content: {
          'application/json': Partial<
            components['schemas']['ResponseMiCuenta']
          > &
            Partial<components['schemas']['ResponseBase']>;
        };
      };
    };
  };
}

export interface external {}
